import { render } from "./AdminAsset.vue?vue&type=template&id=7ce2c912"
import script from "./AdminAsset.vue?vue&type=script&lang=js"
export * from "./AdminAsset.vue?vue&type=script&lang=js"

import "./AdminAsset.vue?vue&type=style&index=0&id=7ce2c912&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__